var _rect, _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAbrigo = function SvgAbrigo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 40,
    fill: "#FEECF1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 28.6406C22.5 27.7345 23.2345 27 24.1406 27C25.0467 27 25.7812 27.7345 25.7812 28.6406V43.8H36.7188V33.23C36.7188 32.2635 37.5023 31.48 38.4688 31.48H48.75C53.5825 31.48 57.5 35.3975 57.5 40.23V55H54.2188V47.16H25.7812V55H22.5V28.6406Z",
    fill: "#C8206F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.25 41.56C33.6662 41.56 35.625 39.5542 35.625 37.08C35.625 34.6058 33.6662 32.6 31.25 32.6C28.8338 32.6 26.875 34.6058 26.875 37.08C26.875 39.5542 28.8338 41.56 31.25 41.56Z",
    fill: "#C8206F"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAbrigo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/abrigo.c563c29f.svg";
export { ForwardRef as ReactComponent };